<script setup lang="ts">
const model = defineModel<string>({ default: '' })
withDefaults(defineProps<{ placeholder?: string; autofocus?: boolean }>(), {
  placeholder: 'Search e.g. Air Fryer, 5.7lt',
  autofocus: false,
})
const emit = defineEmits<{ submit: [value: string] }>()
</script>

<template>
  <form class="searchbox" role="search" @submit.prevent="emit('submit', model.trim())">
    <label class="sr-only" for="searchbox-input">Search for a product</label>
    <input
      id="searchbox-input"
      v-model="model"
      type="search"
      class="searchbox__input"
      :placeholder="placeholder"
      :autofocus="autofocus"
      autocomplete="off"
      enterkeyhint="search"
    />
    <button type="submit" class="searchbox__go" aria-label="Search" :disabled="!model.trim()">
      <AppIcon name="arrow-right" />
    </button>
  </form>
</template>

<style scoped>
.searchbox {
  display: flex;
  height: 48px;
  border: 1.5px solid var(--brand-900);
  border-radius: var(--radius-sm);
  background: var(--white);
  overflow: hidden;
}

.searchbox:focus-within {
  box-shadow: var(--focus-ring);
}

.searchbox__input {
  flex: 1;
  min-width: 0;
  padding: 0 14px;
  border: 0;
  background: transparent;
  font-size: 16px;
}

.searchbox__input:focus {
  outline: none;
}

.searchbox__go {
  flex: none;
  width: 48px;
  border: 0;
  background: var(--brand-600);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchbox__go:disabled {
  opacity: 1;
  background: var(--brand-600);
}
</style>
